import BuildingsApi from "../../../api/buildings-api";

// initial state
const initialState = () => ({
  isFetching: false,
  data: []
});

// actions
const actions = {
  getBuildings: async ({ commit }) => {
    try {
      commit("request");
      const apiResponse = await BuildingsApi.list();
      if (apiResponse && apiResponse.data) {
        commit("getBuildingsSuccess", apiResponse.data);
      } else {
        commit("getBuildingsFailed", apiResponse);
      }
    } catch (e) {
      commit("getBuildingsFailed", e);
    }
  },

  clear: ({ commit }) => {
    commit("clear", initialState());
  }
};

// mutations
const mutations = {
  request: state => {
    state.isFetching = true;
  },
  getBuildingsSuccess: (state, payload) => {
    state.isFetching = false;
    state.data = payload;
  },
  getBuildingsFailed: state => {
    state.isFetching = false;
  },
  clear: (state, initialState) => {
    Object.keys(initialState).forEach(key => {
      state[key] = initialState[key];
    });
  }
};

export default {
  namespaced: true,
  state: initialState(),
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/plugins/store/modules/buildings.js